module.exports = __webpack_public_path__ + "img/StarterPlus.3744d34f.png";